import {GenMapGroup} from '../../generated/serverModels/GenMapGroup';
import {MapLayer} from './map-layer';
import BaseLayer from 'ol/layer/Base';

export class MapGroup extends GenMapGroup {

  public override layers: MapLayer<BaseLayer>[];

  constructor(mapGroup?: MapGroup | GenMapGroup) {
    super(mapGroup);

    if (mapGroup) {
      this.layers = this.layers.map(layer => new MapLayer(layer));
    }
  }
}
